<div>
  <div
    class="tw-flex tw-flex-col tw-p-6 tw-gap-[15px]"
    [ngClass]="{ 'tw-bg-[#E7700033]': !fromTh, 'tw-bg-[#009FE033]': fromTh }"
  >
    <label
      *ngIf="labelText !== ''"
      [for]="id"
      class="tw-font-bold"
      [ngClass]="{
        'tw-text-enstack-onyx-80': !fromTh,
        'tw-text-[#FFFFFF]': fromTh
      }"
    >
      {{ formattedLabelText() }}
    </label>
    <div
      *ngIf="oneOfTheFollowing()"
      class="tw-flex tw-flex-row tw-gap-[35px] tw-h-[96px]"
    >
      <!-- File Input Container -->
      <div
        class="tw-flex tw-flex-col tw-min-w-[163px] tw-w-[96px] tw-h-[96px] tw-items-center tw-justify-center tw-relative"
        [ngClass]="{ 'tw-bg-white': !fromTh, 'tw-bg-[#096999]': fromTh }"
      >
        <label
          [for]="id"
          class="file-label tw-h-full"
          [ngClass]="{
            'has-errors': hasFile() && hasErrors,
            'has-file': hasFile() && !hasErrors,
            'with-border': fromTh
          }"
        >
          @if (documentURL && !hasFile()) {
          <img [src]="documentURL" alt="Document Preview" class="preview-img" />
          <input
            [id]="id"
            type="file"
            class="tw-h-[96px] tw-w-full tw-opacity-0"
            [accept]="buildAcceptString()"
            (change)="onFileChange($event)"
          />
          } @else {
          <div class="input-content tw-absolute">
            @if(!fromTh){
            <img src="../../../../assets/icons/add-icon.svg" class="tw-mb-2" />}
            @else{ <img src="../../../../assets/images/Image Upload.png" />}
            <p
              class="tw-text-[10.25px]"
              [ngClass]="{
                'tw-text-enstack-onyx-80': !fromTh,
                'tw-text-[#FFFFFF]': fromTh
              }"
            >
              {{ placeholder }}
            </p>
          </div>
          <input
            [id]="id"
            type="file"
            class="tw-h-[96px] tw-w-full tw-opacity-0"
            [accept]="buildAcceptString()"
            (change)="onFileChange($event)"
          />
          <button
            *ngIf="hasFile()"
            (click)="onFileRemoved()"
            class="remove-btn"
          >
            <img
              src="assets/icons/file-input-cancel.svg"
              alt="remove file"
              class="remove-icon"
            />
          </button>
          <div *ngIf="hasFile()" class="file-preview" id="xpreview1">
            <!-- -{{file()! | fileUrl}}-1 -->
            <img
              *ngIf="isFileImage()"
              [src]="file()! | fileUrl"
              alt="Document Preview"
              class="preview-img"
            />
            <span *ngIf="!isFileImage()" class="preview-text">{{
              file()!.name
            }}</span>
          </div>
          }
        </label>
      </div>

      <!-- Sample Container -->
      @if (sampleImageUrl && sampleImageUrl.length > 0) {
      <div class="tw-flex tw-flex-col tw-items-center tw-h-[96px]">
        <p
          class="tw-text-[10.25px]"
          [ngClass]="{
            'tw-text-enstack-onyx-80': !fromTh,
            'tw-text-[#FFFFFF]': fromTh
          }"
        >
          {{'sample' | i18next }}
        </p>
        <img
          [src]="sampleImageUrl[0]"
          alt="Sample Document Preview"
          class="sample-image tw-h-full tw-overflow-hidden"
          (click)="openImageDialog(sampleImageUrl)"
        />
      </div>
      }
    </div>
    <div
      *ngIf="!oneOfTheFollowing()"
      class="tw-flex tw-flex-col tw-gap-[35px] tw-w-full"
    >
      <div class="tw-text-enstack-onyx-80 tw-text-[16px]">
        <p>- Income Tax Return</p>
        <p>- Latest Audited Financial Statements</p>
        <p>- Philippine Council for NGO Certification</p>
        <p>- SEC Mandatory Disclosure Form</p>
      </div>
      <!-- File Input Container -->
      <div
        class="tw-flex tw-flex-col tw-bg-white tw-min-w-[163px] tw-w-full tw-h-[96px] tw-items-center tw-justify-center tw-relative"
      >
        <label
          [for]="id"
          class="file-label tw-h-full"
          [ngClass]="{
            'has-errors': hasFile() && hasErrors,
            'has-file': hasFile() && !hasErrors
          }"
        >
          @if (documentURL) {
          <img [src]="documentURL" alt="Document Preview" class="preview-img" />
          <input
            [id]="id"
            type="file"
            class="tw-h-[96px] tw-w-full tw-opacity-0"
            [accept]="buildAcceptString()"
            (change)="onFileChange($event)"
          />
          } @else {
          <div class="input-content tw-absolute">
            <img src="../../../../assets/icons/add-icon.svg" class="tw-mb-2" />
            <p class="tw-text-[10.25px] tw-text-enstack-onyx-80">
              {{ placeholder }}
            </p>
          </div>
          <input
            [id]="id"
            type="file"
            class="tw-h-[96px] tw-w-full tw-opacity-0"
            [accept]="buildAcceptString()"
            (change)="onFileChange($event)"
          />
          <button
            *ngIf="hasFile()"
            (click)="onFileRemoved()"
            class="remove-btn"
          >
            <img
              src="assets/icons/file-input-cancel.svg"
              alt="remove file"
              class="remove-icon"
            />
          </button>
          <div *ngIf="hasFile()" class="file-preview">
            <!-- -{{file()! | fileUrl}}- -->
            <img
              *ngIf="isFileImage()"
              [src]="file()! | fileUrl"
              alt="Document Preview"
              class="preview-img"
            />
            <span *ngIf="!isFileImage()" class="preview-text">{{
              file()!.name
            }}</span>
          </div>
          }
        </label>
      </div>
    </div>
    <div *ngIf="errorMessage !== ''" class="docs-input-error-message">
      {{ errorMessage }}
    </div>
    <div
      *ngIf="labelText == 'Proof of Billing'"
      class="tw-text-enstack-onyx-80 tw-text-center tw-text-[10.25px] tw-mt-2 tw-px-5"
    >
      {{ "file-upload.subtext.proof-of-billing" | i18next }}
    </div>
    <div
      *ngIf="
        labelText == 'Business Registration Certificate / Company Certificate'
      "
      class="tw-text-[#FFFFFF] tw-text-center tw-text-[10.25px] tw-mt-2 tw-px-5"
    >
      {{ "file-upload.subtext.business-registration" | i18next }}
    </div>
  </div>
  <div>
    <div
      *ngIf="
        labelText != 'Proof of Billing' &&
        labelText != 'Business Registration Certificate / Company Certificate'
      "
      class="tw-text-[10.25px] tw-mt-6 tw-px-5 tw-flex tw-flex-col tw-gap-4"
      [ngClass]="{
        'tw-text-enstack-onyx-80': !fromTh,
        'tw-text-[#FFFFFF]': fromTh
      }"
    >
      <p>{{ "advanced-pages.documents.criteria" | i18next }}</p>
      <div class="tw-ml-4 tw-gap-6">
        <div class="tw-flex tw-gap-4">
          <img src="../../../../assets/icons/check.svg" class="tw-mb-2" />
          {{ "advanced-pages.documents.criteria-1" | i18next }}
        </div>
        <div class="tw-flex tw-gap-4">
          <img src="../../../../assets/icons/check.svg" class="tw-mb-2" />
          {{ "advanced-pages.documents.criteria-2" | i18next }}
        </div>
        <div class="tw-flex tw-gap-4">
          <img src="../../../../assets/icons/check.svg" class="tw-mb-2" />
          {{ "advanced-pages.documents.criteria-3" | i18next }}
        </div>
      </div>
    </div>
  </div>
</div>
